import themeConfig from '@config/theme.config';

/**
 * Shared row metrics for sidebar nav + header account menu.
 * Keep padding / type / height identical across both surfaces.
 */
export const MENU_ITEM_SX = {
  boxSizing: 'border-box',
  px: 1.25,
  py: 1.1,
  // Beat MUI MenuItem / ListItemButton default minHeight: 48
  '&&': {
    minHeight: 36,
    height: 36,
  },
  borderRadius: '10px',
  fontSize: 13.5,
  fontWeight: 600,
  lineHeight: 1.3,
  letterSpacing: '-0.01em',
  color: themeConfig.textSecondary,
  transition: 'background-color 160ms ease, color 160ms ease',
};

export const MENU_ITEM_ICON_SX = {
  minWidth: 0,
  mr: 1.25,
  color: 'inherit',
};

export const MENU_ITEM_ICON_SIZE = 18;
